import React, { useState } from 'react';
import recruitingTasksService, {
  TaskPriority, TaskType, TASK_TYPE_LABEL, TASK_PRIORITY_LABEL,
} from '../../../services/recruitingTasks.service';

/** Anlegen einer Recruiting-Aufgabe zu einem Kandidaten. */

interface Props {
  candidateId: string;
  vorbelegung?: { title?: string; task_type?: TaskType };
  onAbbrechen: () => void;
  onAngelegt: () => void;
}

const feld: React.CSSProperties = {
  width: '100%', padding: '7px 9px', fontSize: '0.85rem',
  borderRadius: 'var(--radius-md)', border: '1px solid var(--glass-border)',
  background: 'var(--glass)', color: 'var(--text-primary)',
};

const label: React.CSSProperties = {
  display: 'block', fontSize: '0.74rem', color: 'var(--text-tertiary)', marginBottom: '3px',
};

function inEinerWoche(): string {
  const d = new Date();
  d.setDate(d.getDate() + 7);
  d.setHours(9, 0, 0, 0);
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}

export const CandidateTaskForm: React.FC<Props> = ({ candidateId, vorbelegung, onAbbrechen, onAngelegt }) => {
  const [titel, setTitel] = useState(vorbelegung?.title || '');
  const [typ, setTyp] = useState<TaskType>(vorbelegung?.task_type || 'FOLLOW_UP');
  const [prio, setPrio] = useState<TaskPriority>('NORMAL');
  const [faellig, setFaellig] = useState(inEinerWoche());
  const [speichert, setSpeichert] = useState(false);
  const [fehler, setFehler] = useState<string | null>(null);

  const speichern = async () => {
    setFehler(null);
    if (!titel.trim()) { setFehler('Ein Titel wird benötigt.'); return; }
    try {
      setSpeichert(true);
      await recruitingTasksService.anlegen({
        title: titel.trim(),
        candidate_id: candidateId,
        task_type: typ,
        priority: prio,
        due_at: faellig ? new Date(faellig).toISOString() : null,
      });
      onAngelegt();
    } catch (e: any) {
      setFehler(e?.message || 'Die Aufgabe konnte nicht angelegt werden.');
    } finally {
      setSpeichert(false);
    }
  };

  return (
    <div style={{
      padding: '12px', borderRadius: 'var(--radius-md)',
      border: '1px solid var(--glass-border)', background: 'var(--glass)', display: 'grid', gap: '10px',
    }}>
      <div>
        <span style={label}>Aufgabe</span>
        <input style={feld} value={titel} onChange={(e) => setTitel(e.target.value)} placeholder="z. B. Rückruf vereinbaren" />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
        <div>
          <span style={label}>Art</span>
          <select style={feld} value={typ} onChange={(e) => setTyp(e.target.value as TaskType)}>
            {(Object.keys(TASK_TYPE_LABEL) as TaskType[]).map((t) => (
              <option key={t} value={t}>{TASK_TYPE_LABEL[t]}</option>
            ))}
          </select>
        </div>
        <div>
          <span style={label}>Priorität</span>
          <select style={feld} value={prio} onChange={(e) => setPrio(e.target.value as TaskPriority)}>
            {(Object.keys(TASK_PRIORITY_LABEL) as TaskPriority[]).map((p) => (
              <option key={p} value={p}>{TASK_PRIORITY_LABEL[p].label}</option>
            ))}
          </select>
        </div>
      </div>

      <div>
        <span style={label}>Fällig am</span>
        <input type="datetime-local" style={feld} value={faellig} onChange={(e) => setFaellig(e.target.value)} />
      </div>

      {fehler && <div style={{ color: '#EF4444', fontSize: '0.8rem' }}>{fehler}</div>}

      <div style={{ display: 'flex', gap: '8px' }}>
        <button className="btn btn-primary" style={{ flex: 1 }} disabled={speichert} onClick={speichern}>
          {speichert ? 'Speichert…' : 'Aufgabe anlegen'}
        </button>
        <button className="btn btn-ghost" onClick={onAbbrechen} disabled={speichert}>Abbrechen</button>
      </div>
    </div>
  );
};

export default CandidateTaskForm;
